import ApiService from "@/common/api.service";

export default {
  create(payload) {
    console.log("create payload is..");
    console.log(payload);
    return ApiService.post("sessions/create", payload);
  }
};
